import React, { FC, memo, useCallback, useRef, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import ReactPlayer from 'react-player'
import { SectionContainer } from 'containers/SectionContainer'
import { InnerContainer } from 'containers/InnerContainer'
import { TitleSection } from 'components/TitleSection'
import { ButtonMUI } from 'components/ButtonMUI'
import { TitleBottomSection } from 'components/TitleBottomSection'
import { Partner } from './Partner'


import styles from './styles.module.scss'

interface IProps {
}

const partners = [
  {
    name: 'partnerOpenSea',
    description: 'Our blockchain partner OpenSea offers the best technology there is in its field. OpenSea’s online platform is the largest marketplace for online collectibles.'
  },
  {
    name: 'partnerPolygon',
    description: 'Our blockchain partner Polygon offers the best technology there is in its field. Polygon’s unique second layer brings speed and close to zero transaction costs to our users for our in-game transactions.'
  },
  {
    name: 'partnerTeslasuit',
    description: 'Somnium Space and TESLASUIT are bringing world-exclusive unparalleled sensory sensations to Somnium VR platform.'
  },
  {
    name: 'partnerSansar',
    description: 'This partnership marks a significant step towards achieving full cross-platform interoperability, a pioneering move in the metaverse industry.'
  },
  {
    name: 'partnerBGA',
    description: 'We became a member of Blockchain Game Alliance to contribute towards building a true and decentralized Metaverse.'
  },
  {
    name: 'partnerGemini',
    description: 'We are excited to be partners with one of the leading exchanges in the world. Gemini has invested into Somnium Space and together we believe and work towards an open and decentralized future of The Metaverse.'
  },
  {
    name: 'partnerVrginners',
    description: 'We have partnered with the leader in delivering next-generation virtual and mixed reality pilot training systems to develop our Somnium VR1 headset.'
  },
  {
    name: 'partnerPrushaResearch',
    description: 'We have partnered with a 3D printer manufacturer Prusa Research to further enhance the development of our Somnium VR1 headset.'
  },
  {
    name: 'partnerLYNX',
    description: 'The Lynx team has created an extraordinary AR / VR device (Lynx-r) with openness in mind which will change and revolutionize the way we all think and interact with this market category.'
  },
  {
    name: 'partnerReadyPlayerMe',
    description: 'We are proud users & investors in the leading Avatars platform used by more than 5000 developers across the globe!'
  },
  {
    name: 'partnerLandvault',
    description: 'We work together to bring advertising revenues for our players. It\'s the best and fastest way to monetize your property, measure, analyze how your audience interacts in VR.'
  },
]

const BuildingSection: FC<IProps> = props => {

  return (
    <SectionContainer>
      <InnerContainer style={{ height: '100%', alignItems: 'stretch', borderBottom: '1px solid white' }}>
        <div className={styles.buildingContainer}>
          <TitleSection title={'Building Collaborative Connections'}
                        subTitle={'Our Trusted Partnerships'}/>
          <div className={styles.middleBlock}>
            {partners.map(item => <Partner partner={item} key={item.name}/>)}

          </div>
          <div className={styles.bottomBlock}>
            <TitleBottomSection
              title={'Join Forces with Somnium: Become a Partner in Shaping the Metaverse Future'}
              subTitle={'Discover how you can collaborate with Somnium Space to drive innovation, create immersive experiences, and contribute to the evolution of the metaverse. Embrace the possibilities and embark on a journey of endless creativity.'}/>
            {/*<div className={styles.rightBox}>*/}
            {/*  <ButtonMUI styleType={'white'}*/}
            {/*    // onClick={}*/}
            {/*             type="button"*/}
            {/*             sx={{*/}
            {/*               '&&': {*/}
            {/*                 width: '215px',*/}
            {/*                 height: '60px',*/}
            {/*                 borderRadius: '30px'*/}
            {/*               }*/}
            {/*             }}>Become a Partner</ButtonMUI>*/}
            {/*</div>*/}
          </div>

        </div>
      </InnerContainer>
    </SectionContainer>
  )
}

export default memo(BuildingSection)
